import EnrollmentApplicationModal from 'Agent/Accounts/components/EnrollmentApplication/EnrollmentApplicationModal';
import RequestPolicyInfoReportModal from 'Agent/Accounts/components/RequestPolicyInfoReportModal';
import ClaimsConfirmationModal from 'Agent/Policies/components/ClaimsConfirmationModal';
import AlertsModal from 'Core/components/Alerts/AlertsModal';
import {hideModal, ModalState, ModalStateUnion} from 'Core/ducks/modal';
import React from 'react';
import {connect} from 'react-redux';
import {ReducerState} from 'rootReducer';
import FilterResultsDialog from 'Shared/components/FilterResultsDialog';
import AgentManualEntry from 'Users/components/AgentAdministration/AgentManualEntry';
import SSOConfirmationModal from 'Users/components/SingleSignOn/SSOConfirmationModal';
import SwitchTaxIdModal from 'Users/components/UserAccount/SwitchTaxIdModal';
import DeletePendingRegistrationConfirmationModal from 'Users/components/UserAdministration/DeletePendingRegistrationConfirmationModal';
import Registration from 'Users/components/UserAdministration/Registration';
import ReviewSecurityQuestionsAndResetPassModal from 'Users/components/UserProfile/ReviewSecurityQuestionsAndResetPasswordModal';
import {UserClaims} from 'Users/models/Claims';
import MarketingFormStatesModel from 'Agent/AgentForms/Marketing/components/MarketingFormStatesModel';
import InteractiveFormStatesModel from 'Agent/AgentForms/Interactive/components/InteractiveFormStatesModel';
import CorrespondenceFilterModal from 'Agent/Policies/components/CorrespondenceFilterModal';
import EnrollmentDetailsModal from 'Agent/Policies/components/Applications/EnrollmentDetailsModal';
import A360EnrollmentApplicationModal from 'Agent/Accounts/components/A360EnrollmentApplication/A360EnrollmentApplicationModal';

type ModalConductorProps = {
  hideModal: typeof hideModal;
  modalState: ModalStateUnion;
};

export const ModalConductor = (props: ModalConductorProps) => {
  return ModalState.match(props.modalState, {
    AddAgent: () => <AgentManualEntry />,
    Alerts: alertData => (
      <AlertsModal
        hideModal={() => {
          props.hideModal();
          alertData.onDismissAlerts();
        }}
        alerts={alertData.messages}
      />
    ),
    UploadEnrollmentApplication: enrollmentApplicationData => (
      <EnrollmentApplicationModal
        accountId={enrollmentApplicationData.accountId}
        accountNumber={enrollmentApplicationData.accountNumber}
        servicingAgentNumber={enrollmentApplicationData.servicingAgentNumber}
        hideModal={props.hideModal}
      />
    ),
    UploadA360EnrollmentApplication: enrollmentApplicationData => (
      <A360EnrollmentApplicationModal
        accountNumber={enrollmentApplicationData.accountNumber}
        accountName={enrollmentApplicationData.accountName}
        hideModal={props.hideModal}
      />
    ),
    CorrespondenceFilterModal: () => (
      <CorrespondenceFilterModal
        hideModal={props.hideModal}
      />
    ),
    UsersRegistration: userRegistrationData => (
      <Registration
        onClose={() => {
          userRegistrationData.onClose();
          props.hideModal();
        }}
      />
    ),
    RequestPolicyInfoReport: requestReportProps => (
      <RequestPolicyInfoReportModal
        onClose={props.hideModal}
        accountDetail={requestReportProps.accountDetail}
        userClaims={requestReportProps.userClaims}
        email={requestReportProps.email}
      />
    ),
    None: () => null,
    SwitchTaxId: stateModal => (
      <SwitchTaxIdModal agencyAssociations={stateModal.agencyAssociations} onClose={props.hideModal} />
    ),
    MobileFilter: mobileFilter => <FilterResultsDialog onClose={props.hideModal} {...mobileFilter} />,
    ClaimsConfirmation: claimsConfirmationModalState => (
      <ClaimsConfirmationModal
        policyNumber={claimsConfirmationModalState.policyNumber}
        onClose={props.hideModal}
        eisFlag={claimsConfirmationModalState.eisFlag}
      />
    ),
    DeleteBeneficiaryConfirmation: modalState => <> </>,
    DeletePendingRegistrationConfirmation: modalState => (
      <DeletePendingRegistrationConfirmationModal
        onClose={props.hideModal}
        id={modalState.id}
        filter={modalState.filter}
        encryptedIdentifier={modalState.encryptedIdentifier}
      />
    ),
    SSOConfirmation: modalState => <SSOConfirmationModal message={modalState.message} />,

    ReviewSecurityQuestionsAndResetPassword: (userClaims: UserClaims) => (
      <ReviewSecurityQuestionsAndResetPassModal userClaims={userClaims} />
    ),
    MarketingFormStates: marketingFormStatesData => (
      <MarketingFormStatesModel
        hideModal={() => {
          props.hideModal();
        }}
        states={marketingFormStatesData.states}
      />
    ),
    InteractiveFormStates: interactiveFormStatesData => (
      <InteractiveFormStatesModel
        hideModal={() => {
          props.hideModal();
        }}
        states={interactiveFormStatesData.states}
      />
    ),
    EnrollmentDetails: enrollmentDetailData => (
      <EnrollmentDetailsModal
        onClose={props.hideModal}
        recordInfo={enrollmentDetailData.recordInfo}
      />
    ),
  });
};

export const mapStateToProps = (state: ReducerState) => ({
  modalState: state.modal.modalState,
});

export default connect(mapStateToProps, {
  hideModal,
})(ModalConductor);
